/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
export var DATEINPUT = "pt-dateinput";
export var DATEINPUT_POPOVER = "pt-dateinput-popover";
export var DATEPICKER = "pt-datepicker";
export var DATEPICKER_CAPTION = "pt-datepicker-caption";
export var DATEPICKER_CAPTION_CARET = "pt-datepicker-caption-caret";
export var DATEPICKER_CAPTION_MEASURE = "pt-datepicker-caption-measure";
export var DATEPICKER_CAPTION_SELECT = "pt-datepicker-caption-select";
export var DATEPICKER_DAY = "DayPicker-Day";
export var DATEPICKER_DAY_DISABLED = "DayPicker-Day--disabled";
export var DATEPICKER_DAY_OUTSIDE = "DayPicker-Day--outside";
export var DATEPICKER_DAY_SELECTED = "DayPicker-Day--selected";
export var DATEPICKER_FOOTER = "pt-datepicker-footer";
export var DATEPICKER_MONTH_SELECT = "pt-datepicker-month-select";
export var DATEPICKER_YEAR_SELECT = "pt-datepicker-year-select";
export var DATERANGEPICKER = "pt-daterangepicker";
export var DATERANGEPICKER_CONTIGUOUS = "pt-daterangepicker-contiguous";
export var DATERANGEPICKER_SINGLE_MONTH = "pt-daterangepicker-single-month";
export var DATERANGEPICKER_DAY_SELECTED_RANGE = "DayPicker-Day--selected-range";
export var DATERANGEPICKER_DAY_HOVERED_RANGE = "DayPicker-Day--hovered-range";
export var DATERANGEPICKER_SHORTCUTS = "pt-daterangepicker-shortcuts";
export var DATETIMEPICKER = "pt-datetimepicker";
export var TIMEPICKER = "pt-timepicker";
export var TIMEPICKER_ARROW_BUTTON = "pt-timepicker-arrow-button";
export var TIMEPICKER_ARROW_ROW = "pt-timepicker-arrow-row";
export var TIMEPICKER_DIVIDER_TEXT = "pt-timepicker-divider-text";
export var TIMEPICKER_HOUR = "pt-timepicker-hour";
export var TIMEPICKER_INPUT = "pt-timepicker-input";
export var TIMEPICKER_INPUT_ROW = "pt-timepicker-input-row";
export var TIMEPICKER_MILLISECOND = "pt-timepicker-millisecond";
export var TIMEPICKER_MINUTE = "pt-timepicker-minute";
export var TIMEPICKER_SECOND = "pt-timepicker-second";
export var TIMEPICKER_AMPM_SELECT = "pt-timepicker-ampm-select";
